"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskEntityDataEvent = void 0;
var TaskEntityDataEvent;
(function (TaskEntityDataEvent) {
    TaskEntityDataEvent["Update"] = "task-entity-data:update";
})(TaskEntityDataEvent = exports.TaskEntityDataEvent || (exports.TaskEntityDataEvent = {}));
//# sourceMappingURL=TaskEvent.js.map